import React from "react";

interface Props {
  show: boolean;
  title: string;
  message: string;
  onChooseOther: () => void;
  onClose: () => void;
}

const DoctorUnavailableModal: React.FC<Props> = ({ show, title, message, onChooseOther, onClose }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-xl p-5 w-full max-w-sm shadow-lg">
        <h2 className="text-lg font-semibold text-gray-800 mb-1">{title}</h2>
        <p className="text-sm text-gray-600 mb-4">{message}</p>

        <div className="flex flex-col gap-2">
          <button onClick={onChooseOther} className="bg-teal-500 text-white rounded-lg py-2.5 text-sm font-semibold">
            Pilih Dokter Lain
          </button>
          <button onClick={onClose} className="text-gray-500 text-sm py-1">
            Tutup
          </button>
        </div>
      </div>
    </div>
  );
};

export default DoctorUnavailableModal;
